import { Component, OnInit } from '@angular/core';
import {IonCol, IonFabButton, IonIcon, IonRow, IonText} from '@ionic/angular/standalone';
import {smLinks} from '../../../configs/content/sm-links';

@Component({
  selector: 'app-we-are-here-to-help',
  templateUrl: './we-are-here-to-help.component.html',
  styleUrls: ['./we-are-here-to-help.component.scss'],
  imports: [
    IonRow,
    IonCol,
    IonText,
    IonIcon
  ]
})
export class WeAreHereToHelpComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

  protected readonly smLinks = smLinks;
}
